import { render, staticRenderFns } from "./OneOffLandingPage.vue?vue&type=template&id=5facb6dc&scoped=true"
import script from "./OneOffLandingPage.vue?vue&type=script&lang=js"
export * from "./OneOffLandingPage.vue?vue&type=script&lang=js"
import style0 from "./OneOffLandingPage.vue?vue&type=style&index=0&id=5facb6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5facb6dc",
  null
  
)

export default component.exports